const config = window.TourConfig;

export default config;